$(document)
    .ready(function () {
        // Slick - Content carousel
        var ww = $(window).width();
        var wh = $(window).height();

        if ($(".module-floating-button").length > 0 && $('.hero--sub').length > 0) {
            var heroHeight = $('.hero--sub').height();
            var headerHeight = $("#header").height(); 
            var alertBarHeight = ($('.alert-bar').length > 0) ? $('.alert-bar').height() : 0;
    
            if ($(window).width() < 1101) {
                var hha = heroHeight + headerHeight + alertBarHeight;
                if (wh < hha) {
                    $(".module-floating-button").css('bottom', '20px');
                } else {
                    $(".module-floating-button").css('top', hha - 31);
                }
            } else {
                $(".module-floating-button").css('top', heroHeight + alertBarHeight - 39);
            }
        }

        if ($(".module-content-carousel .carousel").length > 0) {
            var shouldAutoplay = !$('.module-content-carousel').hasClass('module-content-carousel-service');

            $(".module-content-carousel .carousel").slick({
                arrows: true,
                dots: false,
                appendArrows: $(".module-content-carousel .carousel-arrows"),
                prevArrow:
                    '<button type="button" class="carousel-prev"><span class="tm-icon-arrow-left"></span> PREV</button>',
                nextArrow:
                    '<button type="button" class="carousel-next">NEXT <i class="tm-icon-arrow-right"></i></button>',
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                rows: 0,
                autoplay: shouldAutoplay,
                autoplaySpeed: 5000,
                fade: true,
                responsive: [
                    {
                        breakpoint: 992,
                        settings: {
                            arrows: false,
                            dots: true,
                        },
                    },
                ],
            });

            $('.module-content-carousel .tab-menu .heading').on('click', function(e) {
                e.preventDefault();
                var slug = $(this).data('category');
                var carousel = $(".module-content-carousel .carousel");
                var slickIndex = carousel.find('.slick-slide[data-category="' + slug +'"]').data('slick-index');

                if (ww < 992) {
                    if ($('.module-content-carousel .tab-menu').hasClass('open') && !$(this).next().hasClass('has-sub')) {
                        $('.module-content-carousel .tab-menu').removeClass('open');
                        $('.module-content-carousel .mobile-tab-menu').removeClass('open');

                        $('.module-content-carousel .tab-menu li').show();
                        $(this).parent().hide();

                        $('.module-content-carousel .tab-menu li').removeClass('active');
                        $(this).parent().addClass('active');
                        $('.module-content-carousel .mobile-tab-menu').html($(this).text());
                    }
                }

                if (slickIndex != undefined) {
                    carousel.slick('slickGoTo', slickIndex);
                }
            });

            $('.module-content-carousel .mobile-tab-menu').on('click', function(e) {
                e.preventDefault();
                $(this).toggleClass('open');
                $('.module-content-carousel .tab-menu').toggleClass('open');
            });

            if (!$('.module-content-carousel .mobile-tab-menu').hasClass('clicked') && ww < 992) {
                var firstCarouselEl = $('.module-content-carousel .tab-menu li.active');
                firstCarouselEl.hide();
                $('.module-content-carousel .mobile-tab-menu').html(firstCarouselEl.text());
            }
        }

        $(".floating-button-close").on("click", function (e) {
            $(this).parent().toggleClass('closed');
        });

        // Slick - Stories carousel
        if ($(".module-stories-carousel .carousel").length > 0) {
            $(".module-stories-carousel .carousel").slick({
                arrows: true,
                dots: false,
                appendArrows: $(".module-stories-carousel .carousel-arrows"),
                prevArrow: '<button type="button" class="carousel-prev"><span class="tm-icon-arrow-left-green"></span> PREV</button>',
                nextArrow: '<button type="button" class="carousel-next">NEXT <i class="tm-icon-arrow-right-green"></i></button>',
                rows: 0,
                slidesToShow: 4,
                slidesToScroll: 1,
                autoplay: true,
                autoplaySpeed: 5000,
                infinite: true,
                responsive: [
                    {
                        breakpoint: 1280,
                        settings: {
                            slidesToShow: 3,
                        },
                    },
                    {
                        breakpoint: 992,
                        settings: {
                            slidesToShow: 2,
                        },
                    },
                    {
                        breakpoint: 576,
                        settings: {
                            appendArrows: $(".module-stories-carousel .carousel"),
                            prevArrow: '<button type="button" class="slick-prev">Previous</button>',
                            nextArrow: '<button type="button" class="slick-next">Next</button>',
                            slidesToShow: 1,
                        },
                    },
                ],
            }).on('afterChange',
                function (event, slick, currentSlide, nextSlide) {
                    $(this).find(".slick-dots li button").attr("aria-current", "false");
                    $(this)
                        .find(".slick-dots .slick-active button")
                        .attr("aria-current", "true");
                }
            );
        }

        if ($(".yotpo-home-carousel").length > 0) {
            var existCondition = setInterval(function () {
                const carouselWrapper = $(".yotpo-carousel");
                const carouselInner = $(".reviews-carousel-inner");
                const carouselReviews =
                    carouselWrapper.find(".single-carousel");
                const slideCount = carouselReviews.length - 4;
                let start_x,
                    end_x,
                    isDragging = false;
                if (slideCount > 0) {
                    clearInterval(existCondition);
                    const carouselInterval = setInterval(function () {
                        showReview("next");
                    }, 5000);

                    let currentIndex = 0;
                    carouselReviews.slice(-4).remove();

                    carouselReviews.toArray().forEach((item) => {
                        const starDiv = $(item).find(".stars-container");
                        const productName = $(item)
                            .find(".product-name")
                            .first()
                            .text();

                        $(
                            `<div class="product-name">${productName}</div>`
                        ).insertBefore(starDiv);
                    });

                    function showReview(type) {
                        if (type === "next") {
                            currentIndex++;
                            if (currentIndex === slideCount - 1) {
                                currentIndex = -1;
                            }
                        } else {
                            currentIndex--;
                            if (currentIndex === -2) {
                                currentIndex = slideCount - 2;
                            }
                        }

                        let translateValue = -(currentIndex * 36 + 26.5) + "vw";

                        // Check if the screen width is below 992px and adjust translateValue
                        if (window.innerWidth < 992) {
                            translateValue =
                                -(currentIndex * 79.6 + 67.1) + "vw";
                        }

                        carouselWrapper.css(
                            "transform",
                            `translateX(${translateValue})`
                        );
                    }

                    /* Swap */
                    carouselInner.on("mousedown", function (e) {
                        isDragging = true;
                        startX = e.clientX;
                    });

                    carouselInner.on("mousemove", function (e) {
                        clearInterval(carouselInterval);
                        if (isDragging) {
                            var deltaX = e.clientX;

                            if (startX > deltaX) {
                                showReview("next");
                                isDragging = false;
                            } else if (startX < deltaX) {
                                showReview("prev");
                                isDragging = false;
                            }
                        }
                    });

                    carouselInner.on("mouseup", function () {
                        isDragging = false;
                    });

                    /* Drag */
                    carouselInner.on("touchstart", function (e) {
                        clearInterval(carouselInterval);
                        start_x = e.originalEvent.touches[0].clientX;
                    });

                    carouselInner.on("touchend", function (e) {
                        end_x = e.originalEvent.changedTouches[0].clientX;

                        var deltaX = end_x - start_x;

                        if (deltaX > 20) {
                            $(".icon-yotpo-top-corner").addClass(
                                "yotpo-hidden"
                            );
                            $(".icon-yotpo-top-corner").hide();
                            $(".yotpo-tool-tip").hide();
                            showReview("prev");
                        } else if (deltaX < -20) {
                            $(".icon-yotpo-top-corner").addClass(
                                "yotpo-hidden"
                            );
                            $(".icon-yotpo-top-corner").hide();
                            $(".yotpo-tool-tip").hide();
                            showReview("next");
                        }
                    });

                    $(".yotpo_next").on("click", function () {
                        clearInterval(carouselInterval);
                        showReview("next");
                    });

                    $(".yotpo_previous").on("click", function () {
                        clearInterval(carouselInterval);
                        showReview("prev");
                    });

                    // Add a resize event listener to update translateValue on window resize
                    window.addEventListener("resize", function () {
                        // Recalculate translateValue on resize
                        let translateValue = -(currentIndex * 36 + 26.5) + "vw";

                        // Check if the screen width is below 992px and adjust translateValue
                        if (window.innerWidth < 992) {
                            translateValue =
                                -(currentIndex * 79.6 + 67.1) + "vw";
                        }

                        carouselWrapper.css(
                            "transform",
                            `translateX(${translateValue})`
                        );
                    });
                }
            }, 100);
        }
    })
    .on("click", ".header-main .select-country .open-flags", function (e) {
        var expanded = $(this).attr('aria-expanded') === 'true';
        $(this).attr('aria-expanded', !expanded).next(".country-list").slideToggle();
    });

/* Product Carousel */
$(document).ready(function () {
    /* Product Collection Tabs */

    const activate_tab = button => {
        let tabpanel_id = button.attr('aria-controls');
        button.addClass('current').attr("aria-selected", "true").prop('disabled', false).removeAttr('tabindex');
        $(`#${tabpanel_id}`).addClass("product-active");
    }

    const deactivate_all = () => {
        $(".module-product-carousel .collection-tabs button").removeClass("current").attr("aria-selected", "false").prop('disabled', false).attr("tabindex", "-1");
        $(".product-list.product-active").removeClass("product-active");
    }

    deactivate_all();
    activate_tab($(".module-product-carousel .collection-tabs button[data-num='0']"));

    var itemW = 300;
    var centerW = 570;
    var sType = "";

    initCarousel(0, false, false);

    $(".module-product-carousel .collection-tabs button").click(function (e) {
        e.preventDefault();

        if (!$(this).hasClass("current")) {
            $(".module-product-carousel .items > .item").each(function (
                i,
                elm
            ) {
                if (!$(this).hasClass("center-item"))
                    animateOut($(this), false);
                $(this).find(".product-info").css({ opacity: 0 });
            });

            deactivate_all();

            activate_tab($(this));
            $(this).focus();

            initCarousel($(this).data("num"), false, true);

            if (
                $(
                    ".product-list.product-active .ai-carousel .items > .center-item"
                ).length == 1
            ) {
                animateIn(
                    $(
                        ".product-list.product-active .ai-carousel .items > .center-item"
                    ),
                    true
                );
            }
        }
    });

    $(document).on("keydown", "[role='tab']", function(e){
        if([' ', 'Enter', 'ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(e.key)){
            e.preventDefault();
            let tablist = e.target.closest('[role="tablist"]');
            tablist = tablist ? tablist : e.target.closest('[role="presentation"]');
            if(!tablist) return;
            let tabs = tablist ? tablist.querySelectorAll('[role="tab"]') : [];
            let first = tabs ? tabs[0] : null;
            let last = tabs ? tabs[tabs.length -1] : null;
            let prev = e.target.previousSibling || (tabs ? tabs[Math.max(Array.from(tabs).indexOf(e.target) - 1, 0)] : null);
            let next = e.target.nextSibling || (tabs ? tabs[Math.min(Array.from(tabs).indexOf(e.target) + 1, tabs.length-1)] : null);

            switch(e.key){
                case 'Enter':
                case ' ':
                    e.target.click();
                    break;
                case 'ArrowLeft':
                    if(prev) prev.focus();
                    break;
                case 'ArrowRight':
                    if(next) next.focus();
                    break;
                case 'Home':
                    if(first) first.click();
                    break;
                case 'End':
                    if(last) last.click();
                    break;
            }
        }
    });

    /* Product Carousel Init */
    function initCarousel(index = 0, animated = false, centered = false) {

        var carousel = $(
            ".product-list .ai-carousel[data-carousel-num='" + index + "']"
        );
        let focusableElementsSelector = "[role='button'], button:visible, .close, .featherlight-close, video, iframe, a, input:not([type='hidden'])";

        const activateItem = item => {
            deactivateAll();
            let slide = item.find(" > *");
            slide.attr('aria-current', 'true').removeAttr('tabindex').removeAttr('aria-hidden');
            slide.find(focusableElementsSelector).removeAttr('tabindex');
            if (!item.parent().hasClass("ghost")) {
                item.addClass("center-item");
                animateIn(item, true);
            }
        }

        const deactivateAll = () => {
            carousel.find('.items > * > *').removeAttr('aria-current').attr('tabindex', '-1').attr('aria-hidden', 'true');
            carousel.find('.items > *').find(focusableElementsSelector).attr('tabindex', '-1');
            carousel.find('.product-info').css({ opacity: 0, visibility: 'hidden' }); // Hide product information
        }

        if (carousel.data("init") == "init") {
            var cur = carousel.data("current");
            var no = carousel.data("current") + 1;
            var center = carousel.find(
                ".items:nth-child(1) > .item:nth-child(" + no + ")"
            );

            activateItem(center);

            carousel
                .find(".items:nth-child(1) .item")
                .each(function (ind, elm) {
                    var xx = 0;
                    if (cur < ind) {
                        xx = itemW * (ind - cur) + (centered ? centerW : 0);
                    } else if (cur > ind) {
                        xx = itemW * (cur - ind) * -1;
                    } else {
                        xx = 0;
                    }
                    gsap.set(elm, { x: xx });
                });

            var gl = carousel.find(".items.ghost .item.left");

            gl.each(function (ind, elm) {
                var xx = itemW * (gl.length - ind + cur) * -1;
                xx = xx > 0 ? xx + (centered ? centerW : 0) : xx;
                gsap.set(elm, { x: xx });
            });

            var gr = carousel.find(".items.ghost .item.right");

            gr.each(function (ind, elm) {
                var xx = itemW * (ind + (gr.length - cur));
                xx = xx > 0 ? xx + (centered ? centerW : 0) : xx;
                gsap.set(elm, { x: xx });
            });
        } else {
            carousel.data("init", "init");
            carousel.data("current", 0);

            var prevBtn = carousel.find(".carousel-arrows .carousel-prev");
            var nextBtn = carousel.find(".carousel-arrows .carousel-next");
            var slides = $(carousel.find(".items > .item"));
            var speed = 300;
            var current = carousel.data("current") || 0;
            var animating = false;
            var resetIndex = 0;
            var numSlides = slides.length;
            var timeout = 0;
            // Wrap Herbs
            carousel.find(".herbs").wrap("<div class='wrap-herbs'></div>");

            // Clone Items
            if (carousel.find(".items.ghost > .item").length == 0) {
                slides
                    .clone()
                    .addClass("left")
                    .appendTo(carousel.find(".items.ghost"));
                slides
                    .clone()
                    .addClass("right")
                    .appendTo(carousel.find(".items.ghost"));
            }

            // Add dots
            if (carousel.find(".carousel-dots > span").length == 0) {
                for (var i = 0; i < numSlides; i++) {
                    carousel.find(".carousel-dots").append("<span></span>");
                }

                carousel.find(".carousel-dots > span").click(function (e) {
                    e.preventDefault();
                    if (!animating) {
                        animating = true;
                        current = $(this).index();

                        resetIndex = current;
                        carousel.data("current", resetIndex);
                        positionSlides(true, true);
                        setDots();
                    }
                });
            }

            var ghostsL = $(carousel.find(".items.ghost > .item.left"));
            var ghostsR = $(carousel.find(".items.ghost > .item.right"));

            carousel.find(".items.ghost > .item").click(function (e) {
                if (!animating && !$(this).hasClass("center-item")) {
                    animating = true;
                    var index = 0;

                    if ($(this).hasClass("right")) {
                        index = $(this).index() - numSlides;
                        current = current + index + 1;
                    } else {
                        index = $(this).index();
                        current = (ghostsL.length - index) * -1;
                    }

                    resetIndex = index;
                    carousel.data("current", resetIndex);
                    positionSlides(true, true);
                    setDots();
                    $(".module-product-carousel").data("scrolled", true);
                }
            });

            slides.click(function (e) {
                if (!animating && !$(this).hasClass("center-item")) {
                    animating = true;
                    current = $(this).index();
                    resetIndex = current;
                    carousel.data("current", resetIndex);
                    positionSlides(true, true);
                    setDots();
                    $(".module-product-carousel").data("scrolled", true);
                }
            });

            prevBtn.click(function (e) {
                e.preventDefault();
                prevSlide();
            });

            nextBtn.click(function (e) {
                e.preventDefault();
                nextSlide();
            });

            function prevSlide() {
                if (!animating) {
                    animating = true;
                    deactivateAll(); // Added deactivate
                    if (current > -1) current--;

                    resetIndex = current === -1 ? numSlides - 1 : current;
                    carousel.data("current", resetIndex);
                    positionSlides(true, true);
                    setDots();
                }
            }

            function nextSlide() {
                if (!animating) {
                    animating = true;
                    deactivateAll(); // Added deactivate
                    if (current < numSlides) current++;

                    resetIndex = current == numSlides ? 0 : current;
                    carousel.data("current", resetIndex);
                    positionSlides(true, true);
                    setDots();
                }
            }

            /* Drag */
            carousel
                .parent()
                .parent()
                .on("mousedown", function (e) {
                    e.preventDefault();
                    e.stopPropagation();

                    var prevX = e.pageX;

                    $(this).on("mousemove", function (e) {
                        if (!animating) {
                            if (prevX > e.pageX && prevX - 50 > e.pageX) {
                                prevX = e.pageX;
                                nextSlide();
                            } else if (
                                prevX < e.pageX &&
                                prevX < e.pageX - 50
                            ) {
                                prevX = e.pageX;
                                prevSlide();
                            }
                        }
                    });
                });

            $(document).on("mouseup", function (e) {
                carousel.parent().parent().unbind("mousemove");
            });

            /* Swipe */
            carousel
                .parent()
                .parent()
                .on("touchstart", function (e) {
                    e.stopPropagation();

                    var prevX = e.touches[0].pageX;
                    var moveX = prevX;

                    $(this).on("touchmove", function (e) {
                        moveX = e.touches[0].pageX;

                        $(window).scrollTop(e.touches[0].page);

                        if (!animating) {
                            if (prevX > moveX && prevX - 50 > moveX) {
                                prevX = moveX;
                                nextSlide();
                            } else if (prevX < moveX && prevX < moveX - 50) {
                                prevX = moveX;
                                prevSlide();
                            }
                        }
                    });
                });

            $(document).on("touchend", function (e) {
                carousel.parent().parent().unbind("touchmove");
            });

            /* Window Resize */
            $(window).resize(function () {
                setSizes(false, true);
            });

            setSizes(animated, centered);

            function setSizes(animated = false, centered = false) {
                var ww = $(window).width() + 17;

                if (ww > 1024) {
                    sType = "d";
                    itemW = 300;
                    centerW = 600;
                } else if (ww > 768) {
                    sType = "t";
                    itemW = 225;
                    centerW = 445;
                } else {
                    sType = "m";
                    itemW = 160;
                    centerW = 90;
                }

                positionSlides(animated, centered);
                setHeight();
                setDots();
            }

            function setHeight() {
                let carousel = $(".product-list.product-active .ai-carousel");
                let items = carousel.find(".item");
                let maxHeight = 0;
                let spacing = 40;

                for (let i = 0; i < items.length; i++) {
                    let item = $(items[i]);
                    if (maxHeight < item.height()) {
                        maxHeight = item.height();
                    }
                }

                if ($(window).width() > 1024) {
                    spacing = 120;
                    if (maxHeight < 600) maxHeight = 600;
                } else if ($(window).width() > 768) {
                    spacing = 120;
                    if (maxHeight < 600) maxHeight = 400;
                }

                $(".module-product-carousel .collections-list").height(
                    maxHeight + spacing
                );
                $(
                    ".module-product-carousel .collections-list .ai-carousel, .module-product-carousel .collections-list .product-list"
                ).height(maxHeight + spacing);
            }

            /* Window Scroll */
            $(window).scroll(function () {
                scrolled();
            });

            scrolled();

            function scrolled() {
                if (carousel.closest('.product-list').hasClass("product-active")) {
                    var elm = $(".module-product-carousel");

                    if (!animating) {
                        if (elm.data("scrolled") !== true) {
                            if (
                                $(window).scrollTop() >
                                    elm.offset().top - 120 &&
                                $(window).scrollTop() <
                                    elm.offset().top + carousel.height() / 2
                            ) {
                                elm.data("scrolled", true);

                                if (
                                    carousel.find(
                                        ".items:nth-child(1) .center-item"
                                    ).length == 0
                                ) {
                                    positionSlides(true, true);
                                } else {
                                    positionSlides(false, true);
                                }
                            }
                        } else {
                            if (
                                $(window).scrollTop() <
                                    elm.offset().top - 420 ||
                                $(window).scrollTop() >
                                    elm.offset().top + elm.height()
                            ) {
                                elm.data("scrolled", false);
                                positionSlides(true, false);
                                carousel
                                    .find(".product-info")
                                    .css({ visibility: "hidden" });
                            }
                        }
                    }
                }
            }

            function setDots() {
                carousel.find(".carousel-dots span").removeClass("current");
                carousel
                    .find(
                        ".carousel-dots span:nth-child(" +
                            (resetIndex + 1) +
                            ")"
                    )
                    .addClass("current");
            }

            function positionSlides(animated = false, centered = false) {
                deactivateAll(); // Added deactivate
                for (var i = 0; i < slides.length; i++) {
                    let slide = $(slides[i]);

                    var xx;

                    if (slide.hasClass("center-item")) {
                        slide.removeClass("center-item");
                        animateOut(slide, animated);
                    }

                    if (current < i) {
                        xx = itemW * (i - current) + (centered ? centerW : 0);
                    } else if (current > i) {
                        xx = itemW * (current - i) * -1;
                    } else {
                        xx = 0;
                        if (centered) {
                            slide.addClass("center-item");
                            animateIn(slide, animated);
                            activateItem(slide)
                        }
                    }

                    gsap.to(slide, {
                        x: xx,
                        y: sType == "m" ? 0 : "-50%",
                        duration: animated ? 0.5 : 0,
                    });
                }

                // Ghosts
                for (i = 0; i < ghostsL.length; i++) {
                    let ghostL = $(ghostsL[i]);
                    let ghostR = $(ghostsR[i]);

                    var xL = itemW * (ghostsL.length - i + current) * -1;
                    var xR = itemW * (i + (ghostsL.length - current));

                    gsap.to(ghostL, {
                        x: xL > 0 ? xL + (centered ? centerW : 0) : xL,
                        y: sType == "m" ? 0 : "-50%",
                        duration: animated ? 0.5 : 0,
                    });
                    gsap.to(ghostR, {
                        x: xR > 0 ? xR + (centered ? centerW : 0) : xR,
                        y: sType == "m" ? 0 : "-50%",
                        duration: animated ? 0.5 : 0,
                    });

                    if (xL == 0 && centered) {
                        ghostL.addClass("center-item");
                        animateIn(ghostL, animated);
                    } else if (ghostL.hasClass("center-item")) {
                        ghostL.removeClass("center-item");
                        animateOut(ghostL, animated);
                    }

                    if (xR == 0 && centered) {
                        ghostR.addClass("center-item");
                        animateIn(ghostR, animated);
                    } else if (ghostR.hasClass("center-item")) {
                        ghostR.removeClass("center-item");
                        animateOut(ghostR, animated);
                    }
                }

                clearTimeout(timeout);
                timeout = setTimeout(function () {
                    if (current >= slides.length) {
                        current = resetIndex;
                        positionSlides(false, true);
                    } else if (current < 0) {
                        current = resetIndex;
                        positionSlides(false, true);
                    }

                    animating = false;
                }, speed + (centered ? 800 : 0));
            }
        }
    }

    function animateIn(slide, animated = false) {
        var ww = $(window).width() + 17;
        var rightW = 100;

        if (ww < 1024) {
            rightW = 70;
        }
        gsap.fromTo(
            slide.find(".capsule"),
            { width: "40%", height: "40%" },
            {
                width: sType == "d" ? 370 : sType == "t" ? 250 : 175,
                height: sType == "d" ? 540 : sType == "t" ? 344 : 260,
                duration: animated ? 0.3 : 0,
            }
        );
        gsap.fromTo(
            slide.find(".herbs"),
            { width: "40%", height: "40%" },
            {
                width: sType == "d" ? 420 : sType == "t" ? 271 : 210,
                height: sType == "d" ? 570 : sType == "t" ? 368 : 278,
                duration: animated ? 0.5 : 0,
            }
        );
        gsap.fromTo(
            slide.find(".wrap-herbs"),
            { rotate: -25 },
            { rotate: 0, duration: animated ? 0.5 : 0 }
        );
        gsap.fromTo(
            slide.find(".product-info"),
            { right: 140, opacity: 0 },
            {
                right: rightW,
                opacity: 1,
                duration: animated ? 0.3 : 0,
                delay: animated ? 0.5 : 0,
            }
        );
        slide.find(".product-info").css({ visibility: "visible" });
    }

    function animateOut(slide, animated = false) {
        var ww = $(window).width() + 17;
        var rightW = 100;

        if (ww < 1024) {
            rightW = 70;
        }
        if (animated) {
            gsap.fromTo(
                slide.find(".capsule"),
                {
                    width: sType == "d" ? 370 : sType == "t" ? 250 : 175,
                    height: sType == "d" ? 540 : sType == "t" ? 344 : 260,
                },
                { width: "40%", height: "40%", duration: 0.5 }
            );
            gsap.fromTo(
                slide.find(".herbs"),
                {
                    width: sType == "d" ? 420 : sType == "t" ? 271 : 210,
                    height: sType == "d" ? 570 : sType == "t" ? 368 : 278,
                },
                { width: "40%", height: "40%", duration: 1 }
            );
            gsap.fromTo(
                slide.find(".wrap-herbs"),
                { rotate: 0 },
                { rotate: -25, duration: 0.5 }
            );
            gsap.set(slide.find(".product-info"), {
                right: rightW,
                opacity: 0,
            });
        } else {
            gsap.set(slide.find(".capsule"), {
                width: "40%",
                height: "40%",
            });
            gsap.set(slide.find(".herbs"), {
                width: "40%",
                height: "40%",
            });
            gsap.set(slide.find(".product-info"), {
                right: rightW,
                opacity: 0,
            });
        }
    }
});
